export const ADMIN_ROUTE_SEGMENTS = {
  emissionFactors: "emission-factors",
  defaultValues: "default-values",
} as const;

export const ADMIN_EMISSION_FACTORS_PATH = `/${ADMIN_ROUTE_SEGMENTS.emissionFactors}`;

export const ADMIN_DEFAULT_VALUES_PATH = `/${ADMIN_ROUTE_SEGMENTS.defaultValues}`;

export const buildAdminEmissionFactorPath = (emissionFactor: string): string =>
  `${ADMIN_EMISSION_FACTORS_PATH}/${emissionFactor}`;
